import React from 'react';
import { CheckIcon, MinusIcon } from 'lucide-react';
import { Container } from './ui/Container';
import { CTAButton } from './ui/CTAButton';
import { comparisonRows } from '../data/sections';
export function ComparisonTable() {
  return <section id="comparacion" className="border-t border-mp-border bg-mp-dark py-20 md:py-24 scroll-mt-20" data-id="element-63" data-mp="2ppecl2xxxi84">
      <Container data-id="element-64" data-mp="2ukjwjw7s8mtk">
        <div className="overflow-x-auto rounded-2xl border border-mp-border" data-id="element-65" data-mp="3ic8vhvf409jh">
          <table className="w-full min-w-[520px] border-collapse text-left" data-id="element-66" data-mp="3ia4hgknhxu5h">
            <thead data-id="element-67" data-mp="3mdak7ibeh377">
              <tr className="bg-mp-card" data-id="element-68" data-mp="3mbq0youjd6on">
                <th className="px-5 py-4 font-heading text-xs uppercase tracking-wide text-mp-gray md:text-sm" data-id="element-69" data-mp="38eknw4wen7jw">
                  Característica
                </th>
                <th className="px-5 py-4 text-center font-heading text-xs uppercase tracking-wide text-mp-white md:text-sm" data-id="element-70" data-mp="3deywpp5tyliz">
                  Base
                </th>
                <th className="px-5 py-4 text-center font-heading text-xs uppercase tracking-wide text-mp-lime md:text-sm" data-id="element-71" data-mp="21zk1oqx6m3qi">
                  Kit de Ejecución
                </th>
              </tr>
            </thead>
            <tbody data-id="element-72" data-mp="29xwtkj2vg35n">
              {comparisonRows.map((row, i) => <tr key={row.feature} className={i % 2 === 0 ? 'bg-mp-black/40' : 'bg-transparent'} data-id="element-73" data-mp="2nweds6tkixit" data-mpi={i}>
                  <td className="border-t border-mp-border px-5 py-3.5 text-sm text-mp-white md:text-[15px]" data-id="element-74" data-mp="2ivqpvu0mywst">
                    {row.feature}
                  </td>
                  <td className="border-t border-mp-border px-5 py-3.5 text-center" data-id="element-75" data-mp="2sv7t84sf0ylm">
                    {row.base ? <CheckIcon className="mx-auto h-4 w-4 text-mp-white" strokeWidth={2.5} data-id="element-76" data-mp="36l1giio9vat8" /> : <MinusIcon className="mx-auto h-4 w-4 text-mp-gray/50" strokeWidth={2.5} data-id="element-77" data-mp="31nje7b4rftu7" />}
                  </td>
                  <td className="border-t border-mp-border px-5 py-3.5 text-center" data-id="element-78" data-mp="3blfq455iustd">
                    {row.kit ? <CheckIcon className="mx-auto h-4 w-4 text-mp-lime" strokeWidth={2.5} data-id="element-79" data-mp="3ip5gbhsmah21" /> : <MinusIcon className="mx-auto h-4 w-4 text-mp-gray/50" strokeWidth={2.5} data-id="element-80" data-mp="3no8lr3ciepaj" />}
                  </td>
                </tr>)}
              <tr className="bg-mp-card" data-id="element-81" data-mp="185r3g1voz2a">
                <td className="border-t border-mp-border px-5 py-4 font-heading text-sm uppercase text-mp-white md:text-base" data-id="element-82" data-mp="1974hr6d9xn6">
                  Precio
                </td>
                <td className="border-t border-mp-border px-5 py-4 text-center font-heading text-lg text-mp-white md:text-xl" data-id="element-83" data-mp="a7ize5e9nhlf">
                  17,90 €
                </td>
                <td className="border-t border-mp-border px-5 py-4 text-center font-heading text-lg text-mp-lime md:text-xl" data-id="element-84" data-mp="k79ykkdrukru">
                  23,90 €
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div className="mt-8 text-center" data-id="element-85" data-mp="2lymzkycmc8im">
          <p className="font-heading text-lg uppercase text-mp-white sm:text-xl" data-id="element-86" data-mp="2eec3g3dqhyw0">
            Por solo 6 € más añades las dos herramientas de ejecución.
          </p>
          <CTAButton href="#oferta" className="mt-6" showArrow fullWidthMobile data-id="element-87" data-mp="29mkjwcszwtfd">
            Quiero todo por 23,90 €
          </CTAButton>
        </div>
      </Container>
    </section>;
}